import { createUseStyles } from "react-jss";
import { ITheme } from "../../../constants/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  contentDialog: {
    display: "flex",
    flexDirection: "column",
    gap: 0,
    padding: `${theme.spacing.space16}px ${theme.spacing.space32}px`,
    paddingBottom: theme.spacing.space24,
  },
  desc: {
    paddingTop: theme.spacing.space8,
  },
  urlText: {
    width: "fit-content",
    color: "#1877EB",
  },
  qrCode: {
    display: "block",
    width: "160px !important",
    height: "160px !important",
    borderRadius: theme.radius.medium,
  },
}));
